<script>
export default {

	functional: true,

	render(h, context) {
		const MAX_LENGTH = 75;

		let value = context.props.row[ context.props.field.slug ];
		if (value === null) {
			value = '';
		}
		if ((value || '').length > MAX_LENGTH) value = value.slice(0, MAX_LENGTH) + '...';
		return context._v(value);
	}
};
</script>
